import { render, staticRenderFns } from "./PropertyManage.vue?vue&type=template&id=dc7a1330&"
import script from "./PropertyManage.vue?vue&type=script&lang=js&"
export * from "./PropertyManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports